var carouselData = {
  name: 'carousel',
  data: [{
    // dot
    radius: 0,
    verticalWidth: 4,
    verticalHeight: 16,
    horizontalWidth: 16,
    horizontalHeight: 4,
    dotHorizontalPosition: 'center'
  }]
};
export default carouselData;